const warnedMessages = new Set();
/**
 * warn 抛出警告
 * @internal
 * @param {string} 警告内容
 */
function warn(location, message) {
    console.warn(`[Vue3 BaiduMap GL/${location}]: ${message}`);
}
function error(location, message) {
    console.error(`[Vue3 BaiduMap GL/${location}]: ${message}`);
}
function warnOnce(location, message) {
    const mergedMessage = `[Vue3 BaiduMap GL/${location}]: ${message}`;
    if (warnedMessages.has(mergedMessage))
        return;
    warnedMessages.add(mergedMessage);
    console.error(mergedMessage);
}

export { error, warn, warnOnce };
